import React, { useEffect, useState } from "react";
import dayjs from "dayjs";

import { s360ConfigService } from "../../Services/S360Config";

function MessageA98(props) {

  const [a98State, setA98State] = useState({
    name:"",
    value: "",
    actionDone: false,
    options: props.entry.text_data.options,
  });

  useEffect(() => {
    setA98State(prev => ({ ...prev, options: formatData(a98State.options) }));
  }, []);

  const formatData = function (data) {
    let temp = [];
    for (let i = 0; i < data.length; i++) {
      data[i].disabled = false;
      temp.push(data[i]);
    }
    console.log(data);
    return temp;
  };

  const onChangeHandler = (option) => {
    setA98State(prev => ({ ...prev, value: option.value, name: option.name }));
  };

  const onSubmit = () => {
    props.actions.sendMessageWithCode(
      props.entry.keyword,

      {
        name: a98State.name.trim(),
        value: a98State.value.trim(),
      }
    );
    var n = document.getElementsByClassName(
      "s360-message-box-custom-a15-received"
    );
    for (var i = 0; i < n.length; i++) {
      n[i].disabled = true;
      n[i].style.background = "none";
      // onMouseLeave({ "target": n[i]});
    }
    var a = document.getElementsByClassName("oneCheckOption");
    for (var j = 0; j < a.length; j++) {
      a[j].style.pointerEvents = "none";
      a[j].style.opacity = "0.5";
    }
  };
  const messageBoxSubmitStyle = () => {
    return {
      marginLeft: "15px",
      borderWidth: "1px",
      borderStyle: "solid",
      borderColor: s360ConfigService?.config?.configDetails?.primaryColor ?? "#0092ed",
      borderRadius: 20,
      color: s360ConfigService?.config?.configDetails?.primaryColor ?? "#0092ed",
      backgroundColor: "#fff",
      fontWeight: 500,
      fontFamily: s360ConfigService?.config?.configDetails?.fontFamily,
      ...s360ConfigService.config?.customDesign?.messageA98Submit
    };
  };
  return (
    <div className="CheckBoxWithSubmit">
      <div className="CheckBoxContainer">
        {a98State.options.length === 0 ? (
          <p>No Options to display</p>
        ) : (
          a98State.options.map((oneOption) => (
            <div className="oneCheckOption" key={oneOption.name} onClick={() => onChangeHandler(oneOption)}>
              <input
                type="radio"
                style={{ margin: "0px 10px" }}
                value={oneOption.value}
                name={oneOption.name}
                onChange={() => onChangeHandler(oneOption)}
                checked={a98State.value?.trim() === oneOption.value?.trim()}
              />
              {oneOption.name}
            </div>
          ))
        )}
      </div>
      {props.isLastEntry && props.sentTimestamp && (
        <div>
          {dayjs.unix(props.sentTimestamp).format("DD MMM h:mm a")}
        </div>
      )}
      <div className="s360-message-cotainer-received">
        <button
          disabled={props.disabled}
          className="s360-message-box-custom-a15-received"
          onClick={
            a98State.value.length === 0
              ? console.log("not selected")
              : onSubmit
          }
          // onMouseEnter={onMouseEnterButton}
          // onMouseLeave={onMouseLeaveButton}
          style={messageBoxSubmitStyle()}
        >
          {props.entry.data
            ? JSON.parse(props.entry.data).buttonText
            : "Submit"}
        </button>
      </div>
    </div>
  );
}

export default MessageA98;
